'use client';

import { FC } from 'react';
import { useRouter } from 'next/navigation';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import CarouselCard, {
  btnStyles,
} from '../../../common/components/CarouselCard/CarouselCard';
import { FilledArrowRight, RegularStopOrder } from '../../../common/svgIcons';
import { useModalDrawerContext } from '../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { OrderTypeDrawer } from '../OrderTypeDrawer/OrderTypeDrawer';
import { useIsBelowScreenWidth } from '../../../layouts/utils/useIsBelowScreenWidth';
import { ButtonBase, UserAccessModal } from '../../../common/components';
import { AccessInfoType } from '../../../common/utils/userAccess';
import { getAssetTradeUrl } from '../../../route-builders';

interface OrdersCardProps {
  actionText: string;
  title: string;
  subtitle: string;
  isUnavailable?: boolean;
  shouldRedirectToBuyFlow?: boolean;
  assetId?: string;
  drawerTitle?: string;
}

export const OrdersCard: FC<OrdersCardProps> = ({
  actionText,
  subtitle,
  title,
  isUnavailable,
  shouldRedirectToBuyFlow,
  assetId,
  drawerTitle,
}) => {
  const { openDrawer, close, showModal } = useModalDrawerContext();

  const router = useRouter();

  const isMobile = useIsBelowScreenWidth(1024);

  const onClickAction = () => {
    if (isUnavailable) {
      showModal(UserAccessModal, {
        type: AccessInfoType.WarningTrade,
        onModalClose: close,
      });

      return;
    }

    if (assetId) {
      openDrawer(OrderTypeDrawer, {
        title: drawerTitle ?? '',
        position: isMobile ? 'bottom' : 'right',
        onChangeOrderType: (orderType) => {
          router.push(
            getAssetTradeUrl(assetId, { type: 'orderForm', orderType }),
          );

          close();
        },
      });

      return;
    }

    if (shouldRedirectToBuyFlow) {
      router.push(`${NEXT_ROUTES.DISCOVER}?next=order`);

      return;
    }

    router.push(NEXT_ROUTES.ORDERS);
  };

  const action = (
    <ButtonBase
      className={btnStyles}
      noPadding
      visual="ghost"
      onClick={onClickAction}
    >
      <span>{actionText}</span>
      <FilledArrowRight
        color="positive.fill_primary"
        size={16}
        data-dir="rtl"
      />
    </ButtonBase>
  );

  return (
    <CarouselCard
      title={title}
      subtitle={subtitle}
      action={action}
      icon={<RegularStopOrder size={24} />}
    />
  );
};
